export const Keycode = {
	ENTER: 13,
	ESC: 27,
	ARROW_TOP: 38,
	ARROW_BOTTOM: 40,
	ARROW_LEFT: 37,
	ARROW_RIGHT: 39,
};

export const MEDIA = {
	DESKTOP: 976,
};

export const ANCHORS_SELECTOR = `a[href^="#"]`;

export const SLIDER = {
	SLIDES: Array.from(document.querySelectorAll(`section`)),
	HEADER_ANCHORS: Array.from(document.querySelectorAll(`header ${ANCHORS_SELECTOR}`)),
};

export const DIV_SLIDERS = [];

export const SIDEBAR = {
	NODE: document.querySelector(`aside.sidebar`),
	INPUT: document.querySelector(`#sidebar`),
	isOpened: false,
};
